import { useContext } from 'react'
import classnames from 'classnames'

import ShareButtons from 'reactGarden/ShareButtons'
import { EmployeeNotification } from 'reactGarden/EmployeeNotification'

import QuickSearch from 'reactSite/QuickSearch'
import { LocationInfo } from 'reactSite/Location'
import { HeaderContext } from 'reactSite/Header/contexts/HeaderContext'

import { Cart } from '../../../Cart'
import MobileMenu from '../../MobileMenu'
import HeaderLogo from '../../common/HeaderLogo'
import HamburguerMenu from '../../../HamburguerMenu'

const RenderMobile = ({ isAssistedSale, debounceTimer }) => {
  const context = useContext(HeaderContext)

  const { isExpanded, isOpened, toggleMenu } = context

  const overlayClasses = classnames('new-header-mobile-overlay', {
    'is-opened': isOpened
  })

  const layerClasses = classnames('new-header-mobile-layer', {
    'is-opened': isOpened,
    'is-expanded': isExpanded
  })

  return (
    <div className="new-header-mobile">
      <span className={overlayClasses} onClick={toggleMenu} />
      <div className="new-header-mobile-top">
        <div className="new-header-mobile-divisor left">
          <HamburguerMenu trigger={toggleMenu} />
          <HeaderLogo />
        </div>
        <div className="new-header-mobile-divisor right">
          {!isAssistedSale && (
            <a
              href="/minhas-listas-de-desejos"
              title="Minhas listas de Favoritos"
              className="wishlist"
            >
              <i className="glyph glyph-heart"></i>
            </a>
          )}
          <ShareButtons />
          <Cart />

          {isAssistedSale && (
            <a href="/logout" title="Sair da minha conta">
              <i className="glyph glyph-signout" />
            </a>
          )}
        </div>
      </div>
      <div className="new-header-mobile-bottom">
        <QuickSearch debounceTimer={debounceTimer} />
        {<LocationInfo />}
      </div>
      <div className={layerClasses}>
        <nav className="menu">
          <MobileMenu />
        </nav>
      </div>
      <EmployeeNotification />
    </div>
  )
}

export default RenderMobile
